import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const HireFilter = ({ setHire, value }) => {
  const options = [
    {
      label: '1-10',
      value: '1-10',
    },
    {
      label: '11-100',
      value: '11-100',
    },
    {
      label: '101-500',
      value: '101-500',
    },
    {
      label: '501-1000',
      value: '501-1000',
    },
  ]

  const onChange = checkedValues => {
    setHire(checkedValues)
  }
  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} />
  )
}

export default HireFilter
